import React from 'react';
import { GrDocumentText } from 'react-icons/gr';
import { ImStatsDots } from 'react-icons/im';
import { VscServerProcess } from 'react-icons/vsc';
import { FaCloudUploadAlt } from "react-icons/fa";
import { RenderTiles } from '../../components/common';
import { useQuery } from '../../hooks/UseQuery';
import { useParams } from 'react-router-dom';
import ChildHeader from '../../components/ui/ChildHeader';
import PartDetailsHeader from '../../components/ui/PartDeatailsHeader';

const TilesPpap = () => {
  const { partId } = useParams();
  const partName = useQuery('part_name');
  const partNumber = useQuery('part_number');
  const customerName = useQuery('customer_name');
  const ppapTilesObj = [
    {
      sNo: 1,
      link: `/admin/revisionTable/controlplan/${partId}?part_name=${partName}&part_number=${partNumber}`,
      isLink: true,
      clauseNo: 4,
      p: 'CONTROL',
      span: 'PLAN',
      isIcon: true,
      icon: <GrDocumentText size="5rem" color="#c80202" />,
    },
    {
      sNo: 2,
      link: `/admin/spc/${partId}?part_name=${partName}&part_number=${partNumber}`,
      isLink: true,
      clauseNo: 4,
      p: 'SPC',
      span: 'REPORTS',
      isIcon: true,
      icon: <ImStatsDots size="5rem" />,
    },
    {
      sNo: 4,
      link: `/common/processControlStandardList/${partId}?part_name=${partName}&part_number=${partNumber}&customer_name=${customerName}`,
      isLink: true,
      clauseNo: 4,
      p: 'Process Control',
      span: 'Standard',
      isIcon: true,
      icon: <VscServerProcess size="5rem" />,
    },
    {
      sNo: 4,
      link: `/common/pfdUploadDocList?documentType=pfduploaddoc`,
      isLink: true,
      clauseNo: 4,
      p: 'PFD',
      span: '',
      isIcon: true,
      icon: <VscServerProcess size="5rem" />,
    },

    //{
    //  sNo: 5,
    //  link: `/common/ppsList/${partId}?part_name=${partName}&part_number=${partNumber}&customer_name=${customerName}&heading=PPS&documentType=pps`,
    //  isLink: true,
    //  clauseNo: 4,
    //  p: 'UPLOAD',
    //  span: 'PPS',
    //  isIcon: true,
    //  icon: <FaCloudUploadAlt size="5rem" />,
    //},
  ];
  return (
    <>
      <ChildHeader text="DOCUMENT LIST" />
      <PartDetailsHeader
        partName={partName || ''}
        partNumber={partNumber || ''}
      />
      <RenderTiles
        tilesObj={ppapTilesObj}
        justify="start"
        height="100vh"
        columns="0fr"
      />
      ;
    </>
  );
};

export default TilesPpap;
